import { useAuth } from '../../../contexts/AuthContext';

export function useDoctorSpecialty() {
  const { user } = useAuth();
  const specialty = user?.doctor?.specialty?.name?.toLowerCase() || '';

  return {
    isGynecologist: specialty.includes('gyne') || specialty.includes('gyn') || specialty.includes('obstetric'),
    specialty,
  };
}
